namespace GeniuzPOS.LogManage {
    export interface LogJsonForm {
    }

    export class LogJsonForm extends Serenity.PrefixedContext {
        static formKey = 'LogManage.LogJson';
    }
}
